import { useState } from "react";
import type { FaqItem } from "@/mocks/fancha";

export default function TopicFaq({ faq }: { faq: FaqItem[] }) {
  const [open, setOpen] = useState<number>(0);

  return (
    <div className="space-y-3">
      {faq.map((f, i) => {
        const isOpen = open === i;
        return (
          <div key={f.q} className="overflow-hidden rounded-2xl border border-background-200/70 bg-background-50">
            <button
              type="button"
              onClick={() => setOpen(isOpen ? -1 : i)}
              className="flex w-full cursor-pointer items-start justify-between gap-4 px-5 py-4 text-left"
              aria-expanded={isOpen}
            >
              <span className="flex items-start gap-3">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                  <i className="ri-question-line text-sm" />
                </span>
                <span className="font-heading text-base font-bold text-foreground-900">{f.q}</span>
              </span>
              <span
                className={`mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-background-200 text-foreground-700 transition-transform ${
                  isOpen ? "rotate-45 bg-accent-500 text-background-50" : ""
                }`}
              >
                <i className="ri-add-line" />
              </span>
            </button>
            {isOpen && (
              <div className="border-t border-background-200/60 px-5 py-4 pl-14 text-sm leading-7 text-foreground-700">
                {f.a}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}